/*
 * @Author: cc
 * @Date: 2019-12-08 19:24:27
 * @LastEditTime: 2021-04-19 16:06:12
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\weixin\preview\wxPreviewCtrl.js
 * @Description:微信渠道查看页
 */

'use strict';
angular.module('weixinPreviewModule', []).controller('weinxinPreviewCtrl', [
    '$scope',
    '$q',
    '$state',
    'trsHttpService',
    '$stateParams',
    'editcenterRightsService',
    'modalDialog',
    'trsPrintService',
    'localStorageService',
    'editingCenterService',
    'previewService',
    'editingMediatype',
    '$compile',
    '$element',
    function(
        $scope,
        $q,
        $state,
        trsHttpService,
        $stateParams,
        editcenterRightsService,
        modalDialog,
        trsPrintService,
        localStorageService,
        editingCenterService,
        previewService,
        editingMediatype,
        $compile,
        $element
    ) {
        initStatus();
        initData();

        /**
         * '[initStatus description]初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                fromsearch: $stateParams.fromsearch,
                // 是否只是展示（比如稿件收藏），不需要请求权限、上一篇、下一篇等功能
                onlyPreview: $state.params.wxchannelid === '0',
                listOpen: 1, // 基本信息
                authorInfo: true, // 作者信息
                // onlyContent: !!angular.isDefined($state.params.wxplatform),
                isSendState: $state.params.isSendState != 'true',
                btnRightsName: ['wechat.daibian', 'wechat.daishen', 'wechat.yiqianfa', 'wechat.recyclemgr'], // 待编，待审，已送签，回收站
                previewBigFace: {
                    status: false,
                },
                btnRights: {},
                fusionWx: !!$stateParams.iwometadataid, // 融合稿件预览
                isawaitrevise: $state.params.isawaitrevise,
            };
            $scope.data = {
                keywords: [], // 关键词
            };
            getUeditorCss();
        }

        /**
         * [initData description]初始化数据
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            if ($scope.status.fusionWx) {
                requestDataForFusion();
                initBtnRightsForFusion();
            } else {
                requestData().then(() => {
                    previewService.drawVideoMark(false, true);
                    getDraftStage();
                    loadVersionTimePanel();
                });
            }
        }

        /**
         * [getDraftStage description] 获取当前稿件在哪个审核阶段（去除需要传入的wzplatform的情况，主要是从IM来的稿件）
         * @return  {[type]}  [return description]
         */
        function getDraftStage() {
            editingCenterService.getDraftStage($scope.data.item, {
                mediatype: editingMediatype.weixin,
                metadataid: $state.params.wxmetadataid
            }).then((data) => {
                $state.params.wxplatform = data;
                $scope.status.onlyContent = typeof $state.params.wxplatform !== 'undefined';
                initBtnRights();
            });
        }

        /**
         * [getUeditorCss description] 加载编辑器中的相关样式
         * @return {[type]} [description]
         */
        function getUeditorCss() {
            $('.lazyload').remove();
            LazyLoad.css('./lib/ueditor2/themes/iframe.css');
        }

        /**
         * [initBtnRightsForFusion description] 融合微信初始化权限
         * @return {[type]} [description]
         */
        function initBtnRightsForFusion() {
            if (!$stateParams.departmentDocId) {
                editcenterRightsService.initIwoListBtn($stateParams.iwomodalname).then(function(data) {
                    $scope.status.btnRights = data;
                });
            } else {
                getDepartDocAuthority();
            }
            // 获取查看痕迹按钮权限
            editcenterRightsService.initIwoListBtn('iwo.trace').then(function(data) {
                $scope.status.bigFaceRights = !!data['iwo.trace.chakan'] ? 'true' : 'false';
            });

            /**
             * [getDepartDocAuthority description] 部门稿库权限
             *
             * @return  {[type]}  [return description]
             */
            function getDepartDocAuthority() {
                var params = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperkeyOfDeptmentalDoc',
                    DepartmentalDocId: $stateParams.departmentDocId,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    for (var i = 0; i < data.length; i++) {
                        $scope.status.btnRights[data[i]] = true;
                    }
                });
            }
        }

        /**
         * [initBtnRights description] 初始化权限
         * @return {[type]} [description]
         */
        function initBtnRights() {
            if ($scope.status.onlyPreview) {
                return;
            }
            // 获得普通按钮权限
            if (angular.isDefined($state.params.wxplatform)){
                editcenterRightsService
                    .initWeixinListBtn($scope.status.btnRightsName[$state.params.wxplatform], $state.params.wxchannelid)
                    .then(function(rights) {
                        $scope.status.btnRights = rights;
                    });
            }
            // 获取查看痕迹按钮权限
            editcenterRightsService.initWeixinListBtn('wechat.trace', $state.params.wxchannelid).then(function(data) {
                $scope.status.bigFaceRights = data;
            });
        }

        /**
         * [requestDataForFusion description] 查询融合微信数据
         * @return {[type]} [description]
         */
        function requestDataForFusion() {
            var params = {
                serviceid: 'mlf_fusionwechat',
                methodname: 'getVirtualNewsDoc',
                sourceDocId: $stateParams.iwometadataid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.item = data;
                if ($scope.data.item.KEYWORDS) {
                    $scope.data.keywords = $scope.data.item.KEYWORDS.split(';');
                }
                if (!!$state.params.iwometadataid && !!$scope.list) {
                    $scope.data.item.ISNOPAYMENT = $scope.list.ISNOPAYMENT;
                    $scope.data.item.FGD_AUTHINFO = $scope.list.FGD_AUTHINFO;
                    $scope.data.item.FGD_EDITINFO = $scope.list.FGD_EDITINFO;
                    $scope.data.item.DOCSOURCENAME = $scope.list.DOCSOURCENAME; // web
                }
                loadVersionTimePanel();
            });
        }

        /**
         * [requestData description]数据请求函数
         * @return {[type]} [description]
         */
        function requestData() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_wechat',
                methodname: 'getNewsDoc',
                MetaDataId: $stateParams.wxmetadataid,
                fromsearch: $stateParams.fromsearch
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.item = data;
                document.title = data.TITLE;
                editingCenterService.queryVerifyDoc($scope.data.item);
                if ($scope.data.item.KEYWORDS) {
                    $scope.data.keywords = $scope.data.item.KEYWORDS.split(';');
                }
                defer.resolve();
            });
            return defer.promise;
        }
        

        /**
         * [creationAxis description] 创作轴
         * @return {[type]} [description]
         */
        $scope.creationAxis = function() {
            var params = {
                serviceid: 'mlf_releasesource',
                methodname: 'addPersonalMaterialOfTxt',
                PersonalMaterialId: '0',
                metadataid: $scope.data.item.METADATAID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('添加成功', '', 'success', false);
            });
        };

        /**
         * [printBtn description] 打印
         * @return  {[type]}  [return description]
         */
        $scope.printBtn = function() {
            requestPrintVersion($stateParams.wxmetadataid).then(function(data) {
                requestPrintData(data);
            });
        };

        /**
         * [requestPrintVersion description] 打印流程
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        function requestPrintVersion(item) {
            var deferred = $q.defer();
            trsHttpService
                .httpServer(trsHttpService.getWCMRootUrl(), { serviceid: 'mlf_metadatalog', methodname: 'query', MetaDataId: item }, 'get')
                .then(function(data) {
                    deferred.resolve(data.DATA);
                });
            return deferred.promise;
        }

        /**
         * [requestPrintData description]
         * @param   {[type]}  version  [version description] 打印请求详情
         * @return  {[type]}           [return description]
         */
        function requestPrintData(version) {
            var params = {
                serviceid: 'mlf_wechat',
                methodname: 'getNewsDoc',
                MetaDataId: $stateParams.wxmetadataid,
            };
            var printResult = [];
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                var result = data;
                data.VERSION = version;
                data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                printResult.push(result);
                trsPrintService.trsWeixinPrintDocument(printResult);
            });
        }

        /**
         * [pageTurning description] 翻页 上一篇/下一篇
         * @param {int} direction [description]
         * @return {[type]} [description]
         */
        $scope.pageTurning = function(direction) {
            var pageTurningData;
            var metadataid;
            if ($scope.status.fusionWx) {
                pageTurningData = JSON.parse(localStorageService.get('fusionPreview'));
                metadataid = $stateParams.iwometadataid;
            } else {
                pageTurningData = JSON.parse(localStorageService.get('weixinPreview'));
                metadataid = $stateParams.wxmetadataid;
            }
            var toPageData;
            for (var i = 0; i < pageTurningData.length; i++) {
                if (pageTurningData[i].METADATAID === metadataid) {
                    toPageData = pageTurningData[i + direction];
                    break;
                }
            }
            if (!toPageData) {
                var directionTxt = direction === 1 ? '下' : '上';
                modalDialog.alertType('没有' + directionTxt + '一篇了！', '', 'warning', false);
                return;
            }
            if ($scope.status.fusionWx) {
                if ($stateParams.iwomodalname === 'iwo.collect') {
                    fusionGostate(toPageData.DOCTYPEID, toPageData.MLFID, toPageData.CHNLDOCID, toPageData.MLFTYPE, toPageData.DOCCOLLECTRELID);
                } else if ($stateParams.iwomodalname === 'iwo.waste') {
                    fusionGostate(toPageData.DOCTYPE, toPageData.DOCID, toPageData.CHNLDOCID);
                } else {
                    fusionGostate(toPageData.DOCTYPEID, toPageData.METADATAID, toPageData.CHNLDOCID, '', '', toPageData.DEPARTDOCRELID);
                }
            } else {
                $state.go($state.current.name, {
                    wxchnldocid: $stateParams.appchannelid,
                    wxmetadataid: toPageData.METADATAID,
                }, {
                    reload: true
                });
            }
        };

        /**
         * [fusionGostate description] 融合采编预览页跳转
         * @param   {[type]}  doctype         [doctype description]
         * @param   {[type]}  iwometadataid   [iwometadataid description]
         * @param   {[type]}  iwochnldocid    [iwochnldocid description]
         * @param   {[type]}  mlftype         [mlftype description]
         * @param   {[type]}  collectid       [collectid description]
         * @param   {[type]}  departdocrelid  [departdocrelid description]
         * @return  {[type]}                  [return description]
         */
        function fusionGostate(doctype, iwometadataid, iwochnldocid, mlftype, collectid, departdocrelid) {
            mlftype = !mlftype ? '' : mlftype;
            collectid = !collectid ? '' : collectid;
            var routerParams = {
                iwotype: doctype,
                iwomodalname: $stateParams.iwomodalname,
                wzplatform: 0,
                wztypeid: doctype,
                appplatform: 0,
                newspapertype: 2,
                iwometadataid: iwometadataid,
                iwochnldocid: iwochnldocid,
                mlftype: mlftype, // 是否来自资源中心
                iwodoccollectrelid: collectid,
                departdocrelid: departdocrelid,
            };
            routerParams.appdoctype = doctype;
            if (mlftype == 0 || !mlftype) {
                getBindingMediaIds(iwometadataid).then(function(bingdingData) {
                    angular.forEach(bingdingData, function(value, key) {
                        if (value.MEDIATYPE == '1') {
                            routerParams.appsiteid = value.SITEID;
                            routerParams.appchannelid = value.CHANNELID;
                            routerParams.appchnldocid = value.CHNLDOCID;
                            routerParams.appmetadataid = value.VIRTUALDOCID;
                        } else if (value.MEDIATYPE == '2') {
                            routerParams.wzsiteid = value.SITEID;
                            routerParams.wzchannelid = value.CHANNELID;
                            routerParams.wzchnldocid = value.CHNLDOCID;
                            routerParams.wzmetadataid = value.VIRTUALDOCID;
                        } else if (value.MEDIATYPE == '3') {
                            routerParams.paperid = value.CHANNELID; // 预览页与编辑页参数不同
                            routerParams.bzmetadata = value.VIRTUALDOCID; // 预览页与编辑页参数不同
                        }
                    });
                    $state.go($state.current.name, routerParams, {
                        reload: true
                    }); // new
                });
            } else {
                $state.go($state.current.name, routerParams, {
                    reload: true
                }); // new
            }
        }

        /**
         * [getBindingMediaIds description] 获取绑定的渠道的相关id
         * @param {[type]} [iwometadataid] [description] iwo稿件id
         * @return {[type]} [description]
         */
        function getBindingMediaIds(iwometadataid) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_fusioncreate',
                methodname: 'queryFuseMappings',
                sourceDocId: iwometadataid,
                mediaTypes: '',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [bigFace description] 大花脸
         * @return {[type]} [description]
         */
        $scope.bigFace = function() {
            $scope.status.previewBigFace.status = !$scope.status.previewBigFace.status;
        };

        /**
         * [goToEdit description]
         *
         * @return  {[type]}  [return description]
         */
        $scope.goToEdit = function() {
            var exartParams = {
                wxplatform: $state.params.wxplatform, 
                wxchnldocid: $state.params.wxchnldocid,
                isawaitrevise: $state.params.isawaitrevise,
                mediaType: editingMediatype.weixin
            };
            editingCenterService.routerToEditorWithLock(angular.extend($scope.data.item, exartParams));
        };

        /**
         * [loadVersionTimePanel 动态加载流程版本信息]
         *
         * @return  {[type]}  [return description]
         */
        function loadVersionTimePanel() {
            var versionPanel =
                '<version-time-panel incoming-data="data.item"></version-time-panel>';
            versionPanel = $compile(versionPanel)($scope);
            $element.find('versionPanel').append(versionPanel);
        }
    },
]);
